export default __webpack_public_path__ + "static/media/FastWaterMarks.c42aea58.svg";